import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const ColoredTitleImg = styled.img`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: min(155rem, calc(100% - 2 * var(--spacing-sm)));
  text-align: center;

  ${mq.smallOnly} {
    margin-block: -1.5rem;
  }

  ${mq.medium} {
    margin-block: -1rem;
  }
`
